import { Segment, Label, Icon, Image } from "semantic-ui-react";
import { buildStorageUrl } from "../../../../utils";
import { ReactionButton } from "../ReactionButton";
import moment from "moment";
import "moment/locale/es"; // Importa el idioma español
import "./PostAnswer.scss";

export function PostAnswer({ answer }) {
  const postDate = moment.utc(answer.createdAt).local();
  const now = moment.utc().local();
  const isOlderThanOneMonth = now.diff(postDate, "months") > 1;
  const formattedDate = isOlderThanOneMonth
    ? postDate.format("DD/MM/YYYY [a las] hh:mm a")
    : postDate.fromNow();

  return (
    <Segment className="forum-answer">
      <div className="forum-answer__header">
        <div className="forum-answer__avatar">
          <Image
            avatar
            centered
            size="tiny"
            src={buildStorageUrl(answer.User?.avatar)}
          />
        </div>
        <div className="forum-answer__header-info">
          <span className="forum-answer__author">
            {answer.User.firstname} {answer.User.lastname}{" "}
            {answer.User.secondLastname}
          </span>
          <span className="forum-answer__date">{formattedDate}</span>
        </div>
      </div>
      {!!answer.status && (
        <Label
          className="forum-answer__status"
          color={
            answer.isCorrect == null
              ? "grey"
              : answer.isCorrect
                ? "green"
                : "red"
          }
        >
          <Icon
            name={
              answer.isCorrect == null
                ? "clock"
                : answer.isCorrect
                  ? "check circle"
                  : "times circle"
            }
          />
        </Label>
      )}
      <div className="forum-answer__content">{answer.content}</div>
      <div className="forum-answer__footer">
        <ReactionButton targetType="answer" target={answer} />
      </div>
    </Segment>
  );
}
